module.exports = __webpack_public_path__ + "static/media/LiveRate.573a6e7e.svg";